<template>
    <div>
        <div style="min-height: 400px;" ref="agingStockBarChart" v-if="data != null"></div>
        <div style="min-height: 400px; display: flex; align-items: center; justify-content: center;" v-else>
            <p style="margin: 0; font-size: 40px; text-shadow: 2px 2px 2px grey">Loading...</p>
        </div>
    </div>
</template>

<script>
    /* Imports */
    import * as am4core from "@amcharts/amcharts4/core";
    import * as am4charts from "@amcharts/amcharts4/charts";
    import am4themes_animated from "@amcharts/amcharts4/themes/animated";

    export default {
        data () {
            return {
                chart : null,
            }
        },
        props : ['data'],
        mounted () {
            this.createChart();
            this.convertData();
            // this.generateData();
        },
        watch : {
            'data' : {
                deep : true,
                immediate : true,
                handler () {
                    this.chart = null;
                    
                    this.createChart();
                    this.convertData();
                },
            }
        },
        methods : {
            generateData() {
                let length = this.chart.data.length;

                let data = [
                    {dataLabel:'1 Month', value:1345},
                    {dataLabel:'2 Months', value:2345},
                    {dataLabel:'3 Months', value:1235},
                    {dataLabel:'3-6 Months', value:1234},
                    {dataLabel:'>6 Months', value:1245}
                ]

                // for (var i in data) data[i].color = this.chart.colors.next();

                this.chart.addData(data, length);
            },
            convertData () {
                let length = '';

                let data;
                
                if (this.data) {
                    data = [
                        {dataLabel:'1 Month', value:parseInt(this.data['month_1'])},
                        {dataLabel:'2 Months', value:parseInt(this.data['month_2'])},
                        {dataLabel:'3 Months', value:parseInt(this.data['month_3'])},
                        {dataLabel:'3-6 Months', value:parseInt(this.data['month_3_6'])},
                        {dataLabel:'>6 Months', value:parseInt(this.data['month_6'])},
                    ]
                } else {
                    data = [
                        {dataLabel:'No Data', value:0}
                    ]
                }

                this.chart.addData(data, length);
            },
            createChart () {
                /* Chart code */
                // Themes begin
                am4core.useTheme(am4themes_animated);
                // Themes end

                // Create chart instance
                this.chart = am4core.create(this.$refs.agingStockBarChart, am4charts.XYChart);

                this.chart.colors.list = [
                    am4core.color("#B1E5FD"),
                    am4core.color("#FFCDD1"),
                    am4core.color("#B1DFDB"),
                    am4core.color("#C3DFB1"),
                    am4core.color("#CDB1DF")
                ]

                // Add data
                // this.chart.data = [{
                //     "dataLabel": "John",
                //     "value": 35654,
                //     "color": this.chart.colors.next(),
                // }, {
                //     "dataLabel": "Damon",
                //     "value": 65456,
                //     "color": this.chart.colors.next(),
                // }, {
                //     "dataLabel": "Patrick",
                //     "value": 45724,
                //     "color": this.chart.colors.next(),
                // }, {
                //     "dataLabel": "Mark",
                //     "value": 13654,
                //     "color": this.chart.colors.next(),
                // }];

                // Create axes
                let categoryAxis = this.chart.xAxes.push(new am4charts.CategoryAxis());
                categoryAxis.dataFields.category = "dataLabel";
                categoryAxis.renderer.grid.template.disabled = true;
                categoryAxis.renderer.minGridDistance = 30;
                // categoryAxis.renderer.inside = true;
                // categoryAxis.renderer.labels.template.fill = am4core.color("#fff");
                categoryAxis.renderer.labels.template.fontSize = 14;

                categoryAxis.title.text = 'Range Month';
                categoryAxis.title.fontWeight = 'bold';

                let valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
                valueAxis.renderer.grid.template.strokeDasharray = "4,4";
                // valueAxis.renderer.labels.template.disabled = true;
                valueAxis.min = 0;
                valueAxis.title.text="No. of Vehicles";
                valueAxis.title.fontWeight = 'bold';

                // Remove padding
                // chart.paddingBottom = 0;

                // Create series
                let series = this.chart.series.push(new am4charts.ColumnSeries());
                series.dataFields.valueY = "value";
                series.dataFields.categoryX = "dataLabel";
                series.columns.template.propertyFields.fill = "color";
                series.columns.template.propertyFields.stroke = "color";
                series.columns.template.column.cornerRadiusTopLeft = 15;
                series.columns.template.column.cornerRadiusTopRight = 15;
                series.columns.template.tooltipText = "{categoryX}: [bold]{valueY}[/b]";

                series.columns.template.adapter.add("fill", (fill, target)=>{
                    return this.chart.colors.getIndex(target.dataItem.index);
                })
            }
        }
    }
</script>

<style scoped>

</style>